export const LINKEDIN_URL = "https://www.linkedin.com/in/arbindlochanmishra/";
export const GITHUB_URL = "https://github.com/Arbind007";

export const profile = {
  name: "Arbind Lochan Mishra",
  headline: "Identity & Access Management professional",
  summary: "Identity & Access Management professional focused on enterprise identity solutions, access governance, security automation, and emerging identity technologies.",
  snapshot: [
    { value: "IAM", label: "professional direction" },
    { value: "Okta", label: "platform focus" },
    { value: "IGA", label: "governance lens" },
    { value: "AI", label: "emerging frontier" },
  ],
};
